module.exports = __webpack_public_path__ + "img/1970East-051_WEB-min.61fe57ab.jpg";